import React from 'react';

import { Box } from '@material-ui/core';

import isEmpty from 'lodash/isEmpty';
import { array, string } from 'prop-types';

import { useWindowSize } from '../../../../libs/useWindowSize';
import DividerLogo from '../../../DividerLogo';
import FooterDepartment from '../../components/FooterDepartment';
import FooterFlags from '../../components/FooterFlags';
import FooterPayments from '../../components/FooterPayments';
import FooterSocials from '../../components/FooterSocials';

import FooterHelpAndSupport from './FooterHelpAndSupport';
import FooterSecurity from './FooterSecurity';
import { Container, ContentContainer, LegalInfo, ListTitle } from './styles';

function Footer({ department, socials, description, helpSupport, asPath }) {
  const [width] = useWindowSize();
  const isMobile = Boolean(width <= 768);

  const renderComponents = asPath.includes('cliente') || asPath.includes('carrinho') || asPath.includes('totem');

  return (
    <Container>
      <ContentContainer>
        <Box width={{ xs: '100%', sm: 'fit-content' }}>
          <ListTitle>Formas de pagamento</ListTitle>
          <FooterPayments />
        </Box>

        <Box width={{ xs: '100%', sm: 'fit-content' }}>
          <ListTitle>Ajuda e suporte</ListTitle>
          <FooterHelpAndSupport helpSupport={helpSupport} isRender={!renderComponents} />
        </Box>

        {!renderComponents && !isMobile && !isEmpty(department) && (
          <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
            <ListTitle>Departamentos</ListTitle>
            <FooterDepartment department={department} />
          </Box>
        )}

        <Box width={{ xs: '100%', sm: 'fit-content' }}>
          <ListTitle>Certificados e segurança</ListTitle>
          <FooterSecurity />

          {!renderComponents && !isEmpty(socials) && (
            <Box padding="16px 0">
              <ListTitle>Redes sociais</ListTitle>
              <FooterSocials
                facebook={socials.find((elm) => elm.link && elm.link.includes('facebook'))}
                instagram={socials.find((elm) => elm.link && elm.link.includes('instagram'))}
                blog={socials.find((elm) => elm.link && elm.link.includes('blog'))}
                youtube={socials.find((elm) => elm.link && elm.link.includes('youtube'))}
              />
            </Box>
          )}
        </Box>

        <Box
          style={{
            width: '100%',
            display: 'block',
          }}
        >
          <Box width="fit-content" padding="20px 0">
            <FooterFlags />
          </Box>
          {description && <DividerLogo />}
          <LegalInfo container>{description}</LegalInfo>
        </Box>
      </ContentContainer>
    </Container>
  );
}

Footer.defaultProps = {
  department: [],
  socials: [],
  description: '',
  helpSupport: [],
};

Footer.propTypes = {
  department: array,
  socials: array,
  description: string,
  helpSupport: array,
  asPath: string,
};

export default Footer;
